import React, {useState} from 'react';
import './Call911.css';
import GeneralButton from '../regular/GeneralButton';
import { Globals } from '../../../misc/helpers';

var buttonClicked = false;

const Call911 = (obj: any) => {
	let [opacity, setOpacity] = useState(1);

	return (
		<div className="call-911-container modal-disable-select" style={{opacity: opacity, pointerEvents: !buttonClicked ? 'all' : 'none'}}>
			<GeneralButton 
				title={'Tell them to call 9 1 1'}
				text="Tell them to call 911" 
				onClick={ () => {
					if(buttonClicked) {
						return;
					}
					buttonClicked = true;
					var onResume = () => {
						obj.parameters.dispatch({
							type: 'playSequence',
							value: {
								sequenceName: 'Call911',
								onDone: () => {
									if(obj.parameters.onDone) {
										obj.parameters.onDone();
									}
								},
								skipAnimations: Globals.skipAnimations
							}
						});
					}
					if(obj.parameters.onClick) {
						setOpacity(0);
						const camera360Elem = document.getElementsByClassName('rotate-camera-container')[0] as HTMLElement;
						if(camera360Elem){
							camera360Elem.style.opacity = '0';
						}
						const timer = setTimeout(() => {
							obj.parameters.onClick(() => {
								onResume();
							});
							clearTimeout(timer);
						}, 1000);
					} else {
						onResume();
					}
					
				}}/>
		</div>
	);
};

export default Call911;
